module.exports = __webpack_public_path__ + "img/pic7.df5726cf.png";